import React from "react";
import { Skeleton } from "@/components/atomic/Skeleton";

interface ThreadSkeletonProps {
  count?: number;
}

const ThreadSkeletonItem: React.FC = () => {
  return (
    <div className="h-9 mb-[1px] px-2">
      <Skeleton className="h-7 w-full bg-[#5D77BE]/50" />
    </div>
  );
};

const ThreadSkeleton: React.FC<ThreadSkeletonProps> = ({ count = 20 }) => {
  return (
    <div className="space-y-0">
      {Array.from({ length: count }, (_, index) => <ThreadSkeletonItem key={index} />)}
    </div>
  );
};

export { ThreadSkeleton, ThreadSkeletonItem };
